import React, {useEffect, useRef} from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux'
import {useParams} from "react-router";
import PurchasingGroupSectionService from "services/PurchasingGroupSectionService";
import {PurchasingGroupStageSections} from "../constants/PurchasingGroupStageSections";
import PurchasingGroupStage from "../components/PurchasingGroupStage";
import useSnackbar from "hooks/useSnackbar";
import useDebouncedEffect from "hooks/useDebouncedEffect";
import UserService from "services/UserService";
import scheduleReloadTimeout from "../utils/scheduleReloadTimeout";
import Tr from "translations/Translations";


function PurchasingGroupStage2(
    {
        stageSections,
    }
) {
    const params = useParams();
    const groupId = params.id;
    const {enqueueInfoSnackbar} = useSnackbar();
    const reloadTimeout = useRef(0);

    useDebouncedEffect(() => {
        if (reloadTimeout.current) {
            clearTimeout(reloadTimeout.current);
            reloadTimeout.current = 0;
        }

        if (stageSections) {
            (async () => {
                const mainSection = stageSections[PurchasingGroupStageSections.STAGE_2_SECTION];
                if (mainSection && mainSection.schedule) {
                    const serverTime = await UserService.serverTime();
                    let newReloadTimeout = scheduleReloadTimeout(mainSection.schedule, serverTime);
                    if (newReloadTimeout) {
                        reloadTimeout.current = setTimeout(() => {
                            enqueueInfoSnackbar(Tr("purchasing_group_schedule_time_reached"))
                            getStage2Sections();
                        }, newReloadTimeout)
                    }
                }
            })()
        }
        // eslint-disable-next-line
    }, {timeout: 1000, ignoreInitialCall: true}, [stageSections]);

    const getStage2Sections = () => {
        PurchasingGroupSectionService.getStage2Sections(groupId);
    }
    useEffect(() => {
        return () => {
            if (reloadTimeout.current) {
                clearTimeout(reloadTimeout.current);
                reloadTimeout.current = 0;
            }
            PurchasingGroupSectionService.clearResources(PurchasingGroupSectionService.PURCHASING_GROUP_STAGE_SECTIONS_RESOURCE_ID)
        }
        // eslint-disable-next-line
    }, [groupId])

    useEffect(() => {
        if (groupId)
            PurchasingGroupSectionService.getStage2Sections(groupId);
        return () => {
            PurchasingGroupSectionService.clearResources(PurchasingGroupSectionService.PURCHASING_GROUP_STAGE_SECTIONS_RESOURCE_ID)
        }
    }, [groupId])


    return (<PurchasingGroupStage mainSectionName={PurchasingGroupStageSections.STAGE_2_SECTION}/>)
}

PurchasingGroupStage2.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    stageSections: state.resources[PurchasingGroupSectionService.PURCHASING_GROUP_STAGE_SECTIONS_RESOURCE_ID],
}), {})(PurchasingGroupStage2);
